// extracted by mini-css-extract-plugin
export default {"header":"W14AhkfblAhUCsX2zq3C"};